import styles from '../../style.module.scss'

const SummaryLine = ({label, value, hint}) => {
    return (
        <div className={styles.line}>
            <div className={`${styles.label} p-extra-small-size`}>{label}</div>
            <div className={`${styles.value} p-small-size`}>{value}</div>
        </div>
    );
};

export default SummaryLine;